<template>
  <div class="lounge-block">
    <div class="heading-area">
      <h3>
        <a nohref @click="moreInfo = product">{{ shortenName(product.product_name, airport.airport_name) }}</a>
      </h3>
    </div>
    <div class="lounge-wrap">
      <div class="lounge-slider carousel">
        <carousel 
          :perPage="1" 
          :navigationEnabled="true" 
          :paginationEnabled="false" 
        >
          <slide>
            <div class="carousel-item active">
              <img 
                :src="`https://s3-eu-west-1.amazonaws.com/skyassets/resources/hotels-v2/${product.supplier_data.hotel_id}_245x163.jpg`" 
                :alt="`${product.product_name}`"
                @error="$event.target.src = fallbackImage"
              />
            </div>
          </slide>
          <slide v-for="index in 5" :key="index">
            <div class="carousel-item active">
              <img
                :src="`https://skyparkupload1.s3-eu-west-1.amazonaws.com/products/airporthotels/${product.product_id}/${product.product_id}_${index}.jpg`"
                :alt="`${product.product_name}-${index}`" 
                @error="$event.target.src = fallbackImage"
              />
            </div>
          </slide>
        </carousel>
        <span class="more"><a nohref @click="moreInfo = product">{{ $t('airportlounge.results.view_more_info') }} <i class="icon-add"></i></a></span>
      </div>
      <div class="lounge-description">
        <ul class="list list-unstyled">
          <li v-for="(message, key) in salesMessages" :key="key">
            <i class="icon-check_circle"></i>
            {{ message }}
          </li>
        </ul>
        <ul class="info-list list-unstyled">
          <li>
            <span v-tooltip="{ 
              content: `
                <strong>${$t('airporthotel.results.journey')}:</strong>
                <p>${product.supplier_data.airport_transfer }</p>
                <strong>${$t('airporthotel.results.charges')}:</strong>
                <p>${ product.supplier_data.transfer_charges }</p>
              `}">
              <i class="icon-bus"></i>{{ $t('airporthotel.results.transfers') }}
            </span>
          </li>
          <li>
            <span v-tooltip="{ content: product.supplier_data.parking }">
              <i class="icon-directions_car"></i>{{ $t('airporthotel.results.parking') }}
            </span>
          </li>
          <li>
            <span v-tooltip="{ 
              content: `
                <strong>${$t('airporthotel.results.restaurants')}</strong>
                <p>${product.supplier_data.restaurant}</p>
                <strong>${$t('airporthotel.results.breakfast')}:</strong>
                <p>${product.supplier_data.breakfast}</p>
              `}">
            <i class="icon-glass"></i>{{ $t('airporthotel.results.food_drink') }}
            </span>
          </li>
          <li>
            <span v-tooltip="{
              content: `
                <img src='https://maps.googleapis.com/maps/api/staticmap?key=${mapKey}&size=250x250&maptype=roadmap&markers=color:blue%7Clabel:H%7C${product.hotel_data.latitude},${product.hotel_data.longitude}&markers=color:white%7Clabel:A%7C${airport.latitude},${airport.longitude }' />
              `}">
              <i class="icon-location"></i>{{ $t('airporthotel.results.map') }}
            </span>
          </li>
        </ul>
      </div>
    </div>
    <div class="lounge-info">
      <div class="price-detail">
        <strong class="title">{{ $t('airporthotel.results.book_price') }}</strong>
        <div class="wrap" v-if="parseFloat(product.discount) > 0">
          <strong class="price">{{ currency }}{{ parseFloat(product.price).toFixed(2) }}</strong>
          <span class="old-price">{{ currency }}{{ product.full_price }}</span>
        </div>
        <div class="wrap" v-else>
          <strong class="price">{{ currency }}{{ parseFloat(product.price).toFixed(2) }}</strong>
        </div>
      </div>
      <div class="time-info" v-if="parseFloat(product.discount) > 0">
        <span class="save-btn mt-2">
          {{ parseFloat(product.discount_percent) }}% {{ $t('airportparking.results.product.cheaper_discount_saving') }} {{ currency }}{{ product.discount }}
        </span>
      </div>
      <span class="number hotel-room">
        <i class="icon-bed mr-2"></i>1 x {{ product.rooms[0].room_type.value }} {{ $t('airporthotel.results.room') }}
      </span>
      <p class="parking-days">
        <span style="color:#666">{{ product.rooms[0].room_desc }}.</span>
        {{ product.rooms[0].extra_days_message }}.
      </p>
      <a nohref @click="bookNow" class="btn btn-primary">{{ $t('airporthotel.results.book_now') }}</a>
    </div>
  </div>
</template>

<script>
import { get, sync } from "vuex-pathify";
import { Carousel, Slide } from 'vue-carousel';
import { eventBus } from "@/eventBus";
import mixins from "@/mixins";

export default {
  name: "hotel-item",
  mixins: [mixins.validate, mixins.globals, mixins.format], 
  components: { Slide, Carousel },
  props: {
    product: { type: Object, default: () => {}, required: true },
  },
  computed: {
    moreInfo: sync("modals/moreInfo"),
    airport: get("results/airport"),
    salesMessages() {
      return Object.values(this.product.supplier_data.sales_messages).filter(a => a)
    }
  },
  methods: {
    bookNow() {
      eventBus.$emit("SELECTED", this.product);
    }
  }
};
</script>